import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListVATRequest extends IBaseRequest {
    limit:     number;
    offset:    number;
    orderBy?:   string;
    name?:      string;
    id?:        string;
    systemId?:  string;
}

export class ListVATRequest extends BaseRequest implements IListVATRequest {
    public limit: number;
    public offset: number;
    public orderBy?: string;
    public name?: string;
    public id?: string;
    public systemId?: string;

  constructor(server: string, session: string, limit: number, offset: number, orderBy?: string, name?: string, id?: string, systemId?: string) {
    super(server, session);
    this.limit = limit;
    this.offset = offset;
    this.orderBy = orderBy;
    this.name = name;
    this.id = id;
    this.systemId = systemId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.name, 'name');
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.systemId, 'systemId');
    
    return super.wrapperXml('ListVAT', parameters);
  }
}
